import React from 'react';
import { PageHeader } from '../components/dashboard/PageHeader';
import { Card, CardContent, CardHeader, CardTitle } from '../components/Card';
import { BarChart2, Flag, Vote, DollarSign, Users, Palette, Sword, Shield, TrendingUp, TrendingDown, Minus } from 'lucide-react';
import { Briefcase, MessageSquareWarning } from 'lucide-react';
import { RelatedWorkflow } from '../components/dashboard/RelatedWorkflow';
const dimensions = [{
  icon: Flag,
  name: 'Ideologi',
  score: 82,
  status: 'STABIL',
  color: 'emerald',
  triggers: ['Sentimen Pancasila stabil', 'Tidak ada serangan simbol negara signifikan'],
  recs: 'Lanjutkan program kebangsaan rutin.',
  trend: 'flat'
}, {
  icon: Vote,
  name: 'Politik',
  score: 65,
  status: 'WASPADA',
  color: 'amber',
  triggers: ['Polarisasi terkait IKN', 'Manuver elite jelang pemilu lokal'],
  recs: 'Tim Komunikasi: dorong narasi unity, monitoring DPR.',
  trend: 'down'
}, {
  icon: DollarSign,
  name: 'Ekonomi',
  score: 45,
  status: 'KRITIS',
  color: 'red',
  triggers: ['Harga beras naik 18%', 'Hoaks bansos viral', 'Pajak hiburan 75% kontroversial'],
  recs: 'Kemensos & Kementan rilis data resmi 8 jam. Pertimbangan kebijakan stabilisasi.',
  trend: 'down'
}, {
  icon: Users,
  name: 'Sosial',
  score: 58,
  status: 'KRITIS',
  color: 'red',
  triggers: ['Konflik antar suporter bola', 'Demo buruh upah', 'Banjir Demak'],
  recs: 'Pemda terdampak siapkan posko, koordinasi BNPB.',
  trend: 'down'
}, {
  icon: Palette,
  name: 'Budaya',
  score: 88,
  status: 'STABIL',
  color: 'emerald',
  triggers: ['Apresiasi MBG positif', 'Tren budaya lokal viral'],
  recs: 'Lanjutkan kampanye budaya nasional.',
  trend: 'up'
}, {
  icon: Sword,
  name: 'Pertahanan',
  score: 90,
  status: 'STABIL',
  color: 'emerald',
  triggers: ['Tidak ada ancaman militer langsung', 'Latihan gabungan berjalan baik'],
  recs: 'Pertahankan postur defensif.',
  trend: 'flat'
}, {
  icon: Shield,
  name: 'Keamanan',
  score: 72,
  status: 'WASPADA',
  color: 'amber',
  triggers: ['Deepfake audio Presiden', 'Ancaman kunjungan Papua', 'Cyber phishing instansi'],
  recs: 'Aktifkan Protokol Pengamanan Tingkat 2. Koordinasi Polri-BIN-BSSN.',
  trend: 'up'
}];
const colorMap: Record<string, {
  bg: string;
  text: string;
  bar: string;
  border: string;
}> = {
  emerald: {
    bg: 'bg-emerald-500/5',
    text: 'text-emerald-500',
    bar: 'bg-emerald-500',
    border: 'border-emerald-500/30'
  },
  amber: {
    bg: 'bg-amber-500/5',
    text: 'text-amber-500',
    bar: 'bg-amber-500',
    border: 'border-amber-500/30'
  },
  red: {
    bg: 'bg-red-500/5',
    text: 'text-red-500',
    bar: 'bg-red-500',
    border: 'border-red-500/30'
  }
};
export function Ipoleksosbudhankam() {
  const composite = Math.round(dimensions.reduce((a, b) => a + b.score, 0) / dimensions.length);
  return <div className="mx-auto flex w-full max-w-[1600px] flex-col gap-6" data-id="element-2179">
      <PageHeader group="Stabilitas Nasional" title="IPOLEKSOSBUDHANKAM Digital Assessment" description="Analisis stabilitas nasional digital berdasarkan tujuh gatra: Ideologi, Politik, Ekonomi, Sosial, Budaya, Pertahanan, dan Keamanan." icon={BarChart2} data-id="element-2180" />

      <Card className="bg-amber-500/5 border-amber-500/30" data-id="element-2181">
        <CardContent className="p-6 flex items-center justify-between" data-id="element-2182">
          <div data-id="element-2183">
            <p className="font-mono text-xs uppercase tracking-wider text-amber-500/80" data-id="element-2184">
              National Stability Composite
            </p>
            <p className="font-heading text-5xl font-bold text-amber-500 mt-2" data-id="element-2185">
              {composite}
              <span className="text-xl text-amber-500/60" data-id="element-2186">/100</span>
            </p>
            <p className="font-mono text-xs text-muted-foreground mt-1" data-id="element-2187">
              Komposit rata-rata 7 gatra
            </p>
          </div>
          <div className="text-right" data-id="element-2188">
            <span className="font-mono text-sm font-bold bg-amber-500 text-background px-3 py-1.5 rounded" data-id="element-2189">
              WASPADA
            </span>
            <p className="font-mono text-[10px] text-muted-foreground mt-2" data-id="element-2190">
              Trend: -3 vs minggu lalu
            </p>
          </div>
        </CardContent>
      </Card>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2191">
        {dimensions.map(d => {
        const c = colorMap[d.color];
        return <Card key={d.name} className={`bg-card ${c.border}`} data-id="element-2192">
              <CardContent className="p-4" data-id="element-2193">
                <div className="flex items-start justify-between mb-4" data-id="element-2194">
                  <div className="flex items-center gap-3" data-id="element-2195">
                    <div className={`size-10 rounded ${c.bg} border ${c.border} flex items-center justify-center`} data-id="element-2196">
                      <d.icon className={`size-5 ${c.text}`} data-id="element-2197" />
                    </div>
                    <div data-id="element-2198">
                      <p className="font-mono text-[10px] uppercase text-muted-foreground" data-id="element-2199">
                        Gatra
                      </p>
                      <h3 className="font-heading text-xl font-bold" data-id="element-2200">
                        {d.name}
                      </h3>
                    </div>
                  </div>
                  <div className="text-right" data-id="element-2201">
                    <div className="flex items-baseline gap-2" data-id="element-2202">
                      <p className={`font-heading text-3xl font-bold ${c.text}`} data-id="element-2203">
                        {d.score}
                      </p>
                      <span className="font-mono text-xs text-muted-foreground" data-id="element-2204">
                        /100
                      </span>
                    </div>
                    <span className={`font-mono text-[10px] ${c.text}`} data-id="element-2205">
                      {d.status}{' '}
                      {d.trend === 'up' ? <TrendingUp className="size-3 inline" data-id="element-2206" /> : d.trend === 'down' ? <TrendingDown className="size-3 inline" data-id="element-2207" /> : <Minus className="size-3 inline" data-id="element-2208" />}
                    </span>
                  </div>
                </div>

                <div className="w-full h-1.5 bg-muted rounded-full overflow-hidden mb-3" data-id="element-2209">
                  <div className={`h-full ${c.bar}`} style={{
                width: `${d.score}%`
              }} data-id="element-2210" />
                </div>

                <div className="space-y-2" data-id="element-2211">
                  <div data-id="element-2212">
                    <p className="font-mono text-[10px] text-muted-foreground mb-1" data-id="element-2213">
                      PEMICU UTAMA
                    </p>
                    <ul className="space-y-0.5" data-id="element-2214">
                      {d.triggers.map(t => <li key={t} className="text-xs text-muted-foreground flex items-start gap-2" data-id="element-2215">
                          <span className={`${c.text} mt-0.5`} data-id="element-2216">•</span>
                          {t}
                        </li>)}
                    </ul>
                  </div>
                  <div data-id="element-2217">
                    <p className="font-mono text-[10px] text-muted-foreground mb-1" data-id="element-2218">
                      REKOMENDASI
                    </p>
                    <p className="text-xs leading-relaxed" data-id="element-2219">{d.recs}</p>
                  </div>
                </div>
              </CardContent>
            </Card>;
      })}
      </div>

      <RelatedWorkflow currentStep="Monitor IPOLEKSOSBUDHANKAM" nextSteps={[{
      to: '/astagatra',
      icon: Flag,
      label: 'Astagatra Digital',
      desc: 'Lihat ketahanan 8-pilar nasional.'
    }, {
      to: '/public-grievance',
      icon: MessageSquareWarning,
      label: 'Keluhan Publik',
      desc: 'Drill down ke radar keluhan masyarakat.'
    }, {
      to: '/command-tasking',
      icon: Briefcase,
      label: 'Tasking K/L',
      desc: 'Respons cepat ke kementerian per pilar.'
    }, {
      to: '/policy-impact',
      icon: TrendingUp,
      label: 'Policy Impact',
      desc: 'Cek dampak kebijakan terhadap pilar stabilitas.'
    }]} data-id="element-2220" />
    </div>;
}